"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mobx_react_1 = require("mobx-react");
const CreateButton_module_scss_1 = __importDefault(require("./CreateButton.module.scss"));
const CreateButton = ({ children, onboarding, isMobile = false, ...rest }) => {
    var _a;
    const classes = (0, classnames_1.default)('hot-button hot-button--primary', {
        'hot-button--block': isMobile,
        [CreateButton_module_scss_1.default.createButton]: (onboarding === null || onboarding === void 0 ? void 0 : onboarding.showVersionWithOnboarding) && !((_a = onboarding === null || onboarding === void 0 ? void 0 : onboarding.checkList) === null || _a === void 0 ? void 0 : _a.hasModule)
    });
    return ((0, jsx_runtime_1.jsx)("button", { className: classes, ...rest, children: children }));
};
exports.default = (0, mobx_react_1.inject)(({ ContentOnboardingStore, UiStore }) => ({
    onboarding: ContentOnboardingStore,
    isMobile: UiStore.isMobile
}))(CreateButton);
